import loginReducer from './login';
import statusReducer from './status'

export default {
    loginReducer,
    statusReducer,
};